import * as THREE from "three";
import ExtrudedLoopSubGeometry2d from "../compoundSceneGeometry/ExtrudedLoopSubGeometry2d";
import CircleAnnotationData from "../sceneObjectData/CircleAnnotationData";
import { getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";

import { LineMaterial } from "three/addons/lines/LineMaterial.js";

export default class CircleAnnotationGeometry2d extends ExtrudedLoopSubGeometry2d<CircleAnnotationData> {

    private static lineMaterialCache = new WeakMap<SceneObjectStyle, LineMaterial>();
    private static fillMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();
    private static textMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();

    private static getLineMaterial(style: SceneObjectStyle): LineMaterial {
        let mat = CircleAnnotationGeometry2d.lineMaterialCache.get(style);
        if (!mat) {
            mat = new LineMaterial({
                color: style.color,
                linewidth: style.lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),
                depthTest: false
            });
            mat.name = `CircleAnnotation2d-${getSceneObjectStyleName(style)}-Line`;
            CircleAnnotationGeometry2d.lineMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getFillMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = CircleAnnotationGeometry2d.fillMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color, transparent: true, opacity: 0.35, depthTest: false, side: THREE.DoubleSide });
            mat.name = `CircleAnnotation2d-${getSceneObjectStyleName(style)}-Fill`;
            CircleAnnotationGeometry2d.fillMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getTextMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = CircleAnnotationGeometry2d.textMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color });
            mat.name = `CircleAnnotation2d-${getSceneObjectStyleName(style)}-Text`;
            CircleAnnotationGeometry2d.textMaterialCache.set(style, mat);
        }
        return mat;
    }

    constructor() {
        super(
            CircleAnnotationGeometry2d.getLineMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            CircleAnnotationGeometry2d.getFillMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            CircleAnnotationGeometry2d.getTextMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal))
        );
    }

    protected getLineMaterialForStyle(style: SceneObjectStyle): LineMaterial {
        return CircleAnnotationGeometry2d.getLineMaterial(style);
    }

    protected getFillMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return CircleAnnotationGeometry2d.getFillMaterial(style);
    }

    protected getTextMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return CircleAnnotationGeometry2d.getTextMaterial(style);
    }
}
